export const colors = {
    CA_Dark_Green: '#114A17',
    CA_Green: '#81E18B',
    CA_Light_Green: '#D9EDD9',
    CA_Error_Red: '#DF0017',
    CA_Coral: '#FF8B7C',
    CA_Light_Coral: '#FFE6E0',
    CA_Dark_Coral: '#FF6956',
    CA_Blue: '#006EF0',
    CA_Mid_Blue: '#8ABFFF',
    CA_Light_Blue: '#CCE2FC',
    CA_Lightest_Gray: '#f7f7f7',
    CA_Gray: '#F9F9F9',
    CA_Light_Gray: '#DDDDDD',
    CA_Mid_Gray: '#a1a1a1',
    CA_Dark_Gray: '#535353',
    CA_Black: '#000000',
    CA_White: '#ffffff',
    CA_Yellow: '#F2C94C',
    CA_Purple: '#BB6BD9',
}
